import { RegistrationApi } from 'api';
import { t } from 'i18next';
import { useState } from 'react';

const MIN_LENGTH = 5;

export const useIdValidation = () => {
	const [documentValidationMessage, setDocumentValidationMessage] = useState('');

	const validateId = async (value?: string) => {
		if (value && value.length >= MIN_LENGTH) {
			const resp = await RegistrationApi.checkUniqueness({
				field: 'document-number',
				value: value,
			});
			if (!resp?.data?.isError) {
				setDocumentValidationMessage('');
			} else {
				setDocumentValidationMessage(t('documentIdValidation', { field: t('seriesNumberField') }));
			}
		}
	};

	return { documentValidationMessage, validateId };
};
